<template>
  <b-modal
    hide-footer
    size="xl"
    title="Protest Payout Management"
    centered
    id="protest-payout"
  >
    <b-row>
      <b-col cols="12">
        <!-- Upcoming Fixtures -->
        <b-card>
          <b-table
            ref="refProtestList"
            class="mt-2"
            :items="fetchProtestList"
            :fields="tableColumns"
            responsive
            show-empty
            primary-key="campaign"
          >
            <template #empty>
              <div v-if="loadingSession" class="text-center text-dark my-2">
                <p>Loading... Please wait</p>
              </div>

              <div
                v-else-if="!loadingSession && fetchProtestList.length === 0"
                class="text-center text-dark my-2"
              >
                No matching records found
              </div>
            </template>

            <template #cell(status)="{ item }">
              <b-media vertical-align="center">
                <b-badge
                  pill
                  :variant="
                    item.status === 'cancelled'
                      ? 'danger'
                      : item.status === 'completed'
                      ? 'success'
                      : 'primary'
                  "
                  class="text-capitalize"
                >
                  {{ item.status }}
                </b-badge>
              </b-media>
            </template>

            <template #cell(createdTime)="{ item }">
              <b-media vertical-align="center">
                <span class="d-flex align-items-center">
                  {{ format(new Date(item.createdTime), "dd/MM/yyyy") }}
                </span>
                <span class="d-flex align-items-center small">
                  {{ format(new Date(item.createdTime), "hh:mm:ss") }}
                </span>
              </b-media>
            </template>

            <template #cell(scheduledPayoutAt)="{ item }">
              <b-media vertical-align="center">
                <span class="d-flex align-items-center">
                  {{ format(new Date(item.scheduledPayoutAt), "dd/MM/yyyy") }}
                </span>
                <span class="d-flex align-items-center small">
                  {{ format(new Date(item.scheduledPayoutAt), "hh:mm:ss") }}
                </span>
              </b-media>
            </template>

            <template #cell(bets)="{ item }">
              <!-- <b-dropdown
                :id="item.id"
                no-caret
                right
                toggle-class="text-muted bg-light p-0"
                variant="link"
                menu-class="rounded p-0"
                boundary="viewport"
                style="display: inline-block; width: 300px"
                @show="
                  () => {
                    selectedBet = item;
                  }
                "
              > -->
              <!-- <template #button-content> -->
              <feather-icon
                icon="ChevronDownIcon"
                style="border-radius: 4px; cursor: pointer"
                @click="
                  () => {
                    selectedBet = item;
                    $bvModal.show(item.id);
                  }
                "
              />
              <!-- </template> -->
              <b-modal
                hide-footer
                size="xl"
                title="List Betslip"
                centered
                :id="item.id"
              >
                <b-table
                  v-if="!!selectedBet && selectedBet.id === item.id"
                  ref="refBetslipList"
                  class="mt-2"
                  :items="fetchBetslipList"
                  :fields="tableColumnsDetail"
                  responsive
                  show-empty
                >
                  <template #empty>
                    <div
                      v-if="loadingDetail"
                      class="text-center text-dark my-2"
                    >
                      <p>Loading... Please wait</p>
                    </div>

                    <div
                      v-else-if="
                        !loadingDetail && fetchBetslipList.length === 0
                      "
                      class="text-center text-dark my-2"
                    >
                      No matching records found
                    </div>
                  </template>

                  <template #cell(status)="{ item }">
                    <b-media vertical-align="center">
                      <b-badge
                        pill
                        :variant="
                          item.status === 'completed' ? 'success' : 'primary'
                        "
                        class="text-capitalize"
                      >
                        {{ item.status }}
                      </b-badge>
                    </b-media>
                  </template>

                  <template #cell(newBetslipResult)="{ item }">
                    <b-media vertical-align="center">
                      <b-badge
                        pill
                        :variant="
                          JSON.parse(item.detail).detail.newBetslipResult ===
                          'resulted-win'
                            ? 'success'
                            : 'secondary'
                        "
                        class="text-capitalize"
                      >
                        {{ JSON.parse(item.detail).detail.newBetslipResult }}
                      </b-badge>
                    </b-media>
                  </template>

                  <template #cell(newOdds)="{ item }">
                    <b-media vertical-align="center">
                      <div>
                        {{ JSON.parse(item.detail).detail.newOdds }}
                      </div>
                    </b-media>
                  </template>

                  <template #cell(oldOdds)="{ item }">
                    <b-media vertical-align="center">
                      <div>
                        {{ JSON.parse(item.detail).detail.oldOdds }}
                      </div>
                    </b-media>
                  </template>

                  <template #cell(actions)="{ item }">
                    <b-media vertical-align="center">
                      <b-button
                        style="padding: 5px 8px"
                        variant="primary"
                        @click="showModal('payout-real', item)"
                      >
                        Manage
                      </b-button>
                    </b-media>
                  </template>
                </b-table>
                <div class="mx-2 mb-2">
                  <b-row>
                    <b-col
                      cols="12"
                      sm="6"
                      class="d-flex align-items-center justify-content-center justify-content-sm-start"
                    >
                      <span class="text-muted">
                        Showing {{ dataMetaBetslip.from }} to
                        {{ dataMetaBetslip.to }} of
                        {{ dataMetaBetslip.of }} item(s)
                      </span>
                    </b-col>
                    <!-- Pagination -->
                    <b-col
                      cols="12"
                      sm="6"
                      class="d-flex align-items-center justify-content-center justify-content-sm-end"
                    >
                      <b-pagination
                        v-model="currentPageBetslip"
                        :total-rows="totalBetslip"
                        :per-page="perPageBetslip"
                        first-number
                        last-number
                        class="mb-0 mt-1 mt-sm-0"
                        prev-class="prev-item"
                        next-class="next-item"
                      >
                        <template #prev-text>
                          <feather-icon icon="ChevronLeftIcon" size="18" />
                        </template>
                        <template #next-text>
                          <feather-icon icon="ChevronRightIcon" size="18" />
                        </template>
                      </b-pagination>
                    </b-col>
                  </b-row>
                </div>
              </b-modal>
              <!-- </b-dropdown> -->
            </template>

            <template #cell(actions)="{ item }">
              <b-media vertical-align="center">
                <b-dropdown
                  v-if="item.status === 'preview'"
                  dropleft
                  variant="link"
                  toggle-class="p-0"
                  class=""
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="align-middle text-body"
                    />
                  </template>
                  <b-dropdown-item @click="handleEditReason(item)">
                    <feather-icon class="mr-1" icon="EditIcon" />
                    <span>Edit Note</span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="showModal('payout-now', item)">
                    <feather-icon class="mr-1" icon="CheckIcon" />
                    <span>Payout Now</span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="handleEditTime(item)">
                    <feather-icon class="mr-1" icon="EditIcon" />
                    <span>Set Payout Time</span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="showModal('payout-cancel', item)">
                    <feather-icon class="mr-1" icon="XIcon" />
                    <span>Cancel Payout</span>
                  </b-dropdown-item>
                </b-dropdown>
              </b-media>
            </template>
          </b-table>
          <div class="mx-2 mb-2">
            <b-row>
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <span class="text-muted">
                  Showing {{ dataMeta.from }} to {{ dataMeta.to }} of
                  {{ dataMeta.of }} item(s)
                </span>
              </b-col>
              <!-- Pagination -->
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalProtest"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>

      <!-- MODAL CONFIRM -->
      <b-modal
        ref="modal"
        :title="modal.title"
        centered
        cancel-variant="outline-secondary"
        :ok-disabled="isSubmitting"
        @ok="handleSubmitModal"
      >
        <b-row v-if="action.type === 'edit-reason'" class="text-body mb-1">
          <b-col cols="12" sm="2" class="mt-1"> Note </b-col>
          <b-col cols="12" sm="9">
            <b-form-input
              id="note-input"
              v-model="reason"
              placeholder="Enter note..."
            />
          </b-col>
        </b-row>

        <b-form-group
          v-if="action.type === 'payout-reschedule'"
          label="Reschedule Time"
          class="text-black"
        >
          <flat-pickr v-model="rescheduleTime" :config="configDate" />
        </b-form-group>

        <b-form-group
          v-if="action.type === 'payout-real'"
          label="Payout Number"
          class="text-black"
        >
          <b-form-input
            id="payout-number"
            v-model="finalDeltaPayout"
            placeholder="Enter number..."
          />
        </b-form-group>

        <b-card-text style="color: black">
          {{ modal.content }}
        </b-card-text>
        <template #modal-ok>
          <Spinner v-if="isSubmitting" />
          <span v-else>Submit</span>
        </template>
      </b-modal>
    </b-row>
  </b-modal>
</template>
<script>
import {
  BCard,
  BTable,
  BFormCheckbox,
  BButton,
  BAlert,
  BFormGroup,
  BRow,
  BCol,
  BFormRadio,
  BFormRadioGroup,
  BFormInput,
  BPagination,
  BMedia,
  BModal,
  BCardBody,
  BBadge,
  BDropdown,
  BDropdownItem,
  BCardText,
} from "bootstrap-vue";
import VSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import { formatCurrencyBuiltInFunc } from "@/helpers/utils";
import { mapActions, mapState } from "vuex";
import useToastHandler from "@/services/toastHandler";
import { computed, ref, watch } from "@vue/composition-api";
import { format } from "date-fns";
import Spinner from "@/@core/components/Spinner.vue";

export default {
  components: {
    BModal,
    BCard,
    BTable,
    BFormCheckbox,
    BButton,
    BAlert,
    BFormGroup,
    BRow,
    BCol,
    VSelect,
    flatPickr,
    FeatherIcon,
    BFormRadio,
    BFormRadioGroup,
    BFormInput,
    BPagination,
    BMedia,
    BCardBody,
    BBadge,
    BDropdown,
    BDropdownItem,
    BCardText,
    Spinner,
  },
  data() {
    return {
      tableColumns: [
        { key: "createdTime" },
        { key: "id" },
        { key: "legId" },
        { key: "status" },
        { key: "scheduledPayoutAt", label: "payout time" },
        { key: "bets" },
        { key: "reason" },
        { key: "actions" },
      ],
      tableColumnsDetail: [
        // { key: "createdTime" },
        // { key: "id" },
        { key: "displayId", label: "Legid" },
        { key: "oldPayout" },
        { key: "newPayout" },
        { key: "newBetslipResult" },
        { key: "oldOdds" },
        { key: "newOdds" },
        { key: "finalDeltaPayout", label: "payout" },
        { key: "status" },
        { key: "note" },
        { key: "actions" },
      ],
      action: {
        type: "",
        item: "",
      },
      modal: {
        title: "",
        content: "",
      },
      selectedBet: null,
      reason: "",
      rescheduleTime: null,
      configDate: {
        enableTime: true,
        altFormat: "Y-m-d H:i:s",
        enableSeconds: true,
        altInput: true,
        static: true,
      },
      finalDeltaPayout: null,
    };
  },
  computed: {
    ...mapState("trading/protest", [
      "loadingSession",
      "loadingDetail",
      "loadingUpdateSession",
      "loadingUpdateDetail",
    ]),
    isSubmitting() {
      return this.loadingUpdateSession || this.loadingUpdateDetail;
    },
  },
  methods: {
    ...mapActions({
      getListPayoutRecalculationSession:
        "trading/protest/getListPayoutRecalculationSession",
      getPayoutRecalculationDetail:
        "trading/protest/getPayoutRecalculationDetail",
      updatePayoutSession: "trading/protest/updatePayoutSession",
      updatePayoutByBetslip: "trading/protest/updatePayoutByBetslip",
    }),
    async fetchProtestList() {
      const data = await this.getListPayoutRecalculationSession({
        page: this.currentPage,
        limit: this.perPage,
      });
      this.totalProtest = data.pagination.total;

      if (!data)
        return this.showToastError(false, "Error fetching promotions list");
      return data.data;
    },
    async fetchBetslipList() {
      const data = await this.getPayoutRecalculationDetail({
        page: this.currentPageBetslip,
        limit: this.perPageBetslip,
        sessionId: this.selectedBet.id,
      });
      this.totalBetslip = data.pagination.total;

      if (!data)
        return this.showToastError(false, "Error fetching betslip list");
      return data.data;
    },
    setModal(title, content) {
      this.modal.title = title;
      this.modal.content = content;
    },

    showModal(type, item) {
      this.action = { item, type };
      if (type === "edit-reason") {
        this.setModal(
          "Update Reason",
          `Are you sure you want to change the note of race ${item.legId}?`
        );
      }

      if (type === "payout-now") {
        this.setModal(
          "Update Payout Time",
          `Are you sure you want to payout immediately?`
        );
      }

      if (type === "payout-reschedule") {
        this.setModal(
          "Reschedule Payout",
          `Are you sure you want to change payout time?`
        );
      }

      if (type === "payout-real") {
        if (!!this.finalDeltaPayout) this.finalDeltaPayout = null;
        this.setModal(
          "Payout Number",
          `Are you sure you want to change total payout of betID ${item.displayId}?`
        );
      }

      if (type === "payout-cancel") {
        this.setModal(
          "Cancel Payout",
          `Are you sure you want to cancel payout of race ${item.legId}?`
        );
      }

      this.$refs.modal.show();
    },

    async handleSubmitModal(event) {
      event.preventDefault();
      const { item, type } = this.action;

      if (type === "edit-reason") await this.handleUpdateReason(item);
      if (type === "payout-now") await this.handleUpdatePayoutNow(item);
      if (type === "payout-reschedule") await this.handleUpdatePayoutTime(item);
      if (type === "payout-real") await this.handleUpdatePayoutNumber(item);
      if (type === "payout-cancel") await this.handleCancelPayout(item);

      if (!this.isSubmitting) {
        this.$nextTick(() => {
          this.$refs.modal.hide();
        });
      }
    },
    async handleUpdateReason(item) {
      const res = await this.updatePayoutSession({
        sessionId: item.id,
        reason: this.reason,
        status: item.status,
      });
      if (res) {
        this.showToastSuccess(true, "Reason updated successfully!");
        this.refetchData();
      }
    },
    handleEditReason(item) {
      this.reason = item.reason;
      this.showModal("edit-reason", item);
    },
    async handleUpdatePayoutNow(item) {
      const res = await this.updatePayoutSession({
        sessionId: item.id,
        status: "completed",
      });
      if (res) {
        this.showToastSuccess(true, "Payout successfully!");
        this.refetchData();
      }
    },
    handleEditTime(item) {
      this.rescheduleTime = new Date(item.scheduledPayoutAt);
      this.showModal("payout-reschedule", item);
    },
    async handleUpdatePayoutTime(item) {
      const res = await this.updatePayoutSession({
        sessionId: item.id,
        scheduledPayoutAt: new Date(this.rescheduleTime).toISOString(),
      });
      if (res) {
        this.showToastSuccess(true, "Updated payout time successfully!");
        this.refetchData();
      }
    },
    async handleUpdatePayoutNumber(item) {
      const res = await this.updatePayoutByBetslip({
        id: item.id,
        finalDeltaPayout: Number(this.finalDeltaPayout),
      });
      if (res) {
        this.showToastSuccess(true, "Updated payout number successfully!");
        this.refetchDataBetslip();
      }
    },
    async handleCancelPayout(item) {
      const res = await this.updatePayoutSession({
        sessionId: item.id,
        status: "cancelled",
      });
      if (res) {
        this.showToastSuccess(true, "Cancelled payout successfully!");
        this.refetchData();
      }
    },
  },
  setup() {
    const refProtestList = ref(null);
    const totalProtest = ref(0);
    const currentPage = ref(1);
    const perPage = ref(10);

    const refBetslipList = ref(null);
    const totalBetslip = ref(0);
    const currentPageBetslip = ref(1);
    const perPageBetslip = ref(5);

    const dataMeta = computed(() => {
      const localItemsCount = refProtestList.value
        ? refProtestList.value.localItems.length
        : 0;
      return {
        from:
          perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: totalProtest.value,
      };
    });

    const dataMetaBetslip = computed(() => {
      const localItemsCount = refBetslipList.value
        ? refBetslipList.value.localItems.length
        : 0;
      return {
        from:
          perPageBetslip.value * (currentPageBetslip.value - 1) +
          (localItemsCount ? 1 : 0),
        to:
          perPageBetslip.value * (currentPageBetslip.value - 1) +
          localItemsCount,
        of: totalBetslip.value,
      };
    });

    const refetchData = () => {
      refProtestList.value.refresh();
    };

    watch([currentPage], () => {
      refetchData();
    });

    const refetchDataBetslip = () => {
      refBetslipList.value.refresh();
    };

    watch([currentPageBetslip], () => {
      refetchDataBetslip();
    });

    const { showToastError, showToastSuccess } = useToastHandler();

    return {
      formatCurrencyBuiltInFunc,

      showToastError,
      showToastSuccess,
      refProtestList,

      totalProtest,
      currentPage,
      perPage,
      dataMeta,
      refetchData,
      format,

      totalBetslip,
      currentPageBetslip,
      perPageBetslip,
      dataMetaBetslip,
      refetchDataBetslip,
      refBetslipList,
    };
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";

.btn-action {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  border: 1px solid var(--bg-color);
  svg {
    color: var(--bg-color);
  }
  &:hover {
    background: var(--bg-color);
    svg {
      color: white;
    }
  }
}
.promotion-type {
  background: var(--bg-color);
  color: var(--color);
}
.custom-width {
  max-width: fit-content !important;
}
</style>
